import axios from "axios";
import * as ActionType from "./shorts.type";
import { setToast } from "../../../util/toast";
import { apiInstanceFetch } from "../../../util/api";
import { baseURL, secretKey } from "../../../util/config";

export const updateFeature =
  (Data, type, start, limit, startDate, endDate) => (dispatch) => {
    console.log(type, start, limit, startDate, endDate);
    let formatData = JSON.stringify({ feature: Data });

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}admin/video/updatefeature`,
      headers: {
        "Content-Type": "application/json",
      },
      data: formatData,
    };
    axios
      .request(config)
      .then((res) => {
        if (res.data.status) {
          //dispatch(getShortsApi("All", type, start, limit, startDate, endDate));
          dispatch({
            type: ActionType.UPDATEFEATURE,
            payload: { featureIds: res.data.ids, feature: res.data.feature },
          });
          setToast("success", res.data.message);
        }
      })
      .catch((error) => console.log(error));
  };
export const getShortsApi =
  (filter, type, start, limit, startDate, endDate) => (dispatch) => {
    let data = {
      searchClip: filter.filter1 || "",
      channelId: filter.filter2 || "",
      feature: filter.filter3 || "",
    };

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}admin/video/videosOrShorts?videoType=${type}&start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`,
      headers: {
        key: "aw6xayDawf3cUm22QtMHlxfL8lZESl0W",
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(config)
      .then((res) => {
        dispatch({
          type: ActionType.GET_SHORTS,
          payload: {
            shortsData: res.data.videosOrShorts,
            totalShorts: res.data.totalVideosOrShorts,
          },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

export const createShort = (Data) => (dispatch) => {
  const formData = new FormData();
  formData.append("videoUrl", Data.videoUrl);
  formData.append("videoImage", Data.videoImage, "thumbnail.jpg");
  formData.append("title", Data.title);
  formData.append("description", Data.description);
  formData.append("hashTag", Data.hashTag);
  formData.append("latitude", Data.latitude);
  formData.append("location", Data.location);
  formData.append("longitude", Data.longitude);
  formData.append("scheduleTime", Data.scheduleTime);
  formData.append("scheduleType", Data.scheduleType);
  formData.append("userId", Data.userId);
  formData.append("videoTime", Data.videoTime);
  formData.append("videoType", Data.videoType);
  formData.append("visibilityType", Data.visibilityType);
  formData.append("channelId", Data.channelId);
  formData.append("audienceType", Data.audienceType);
  formData.append("commentType", Data.commentType);
  axios
    .post(`${baseURL}admin/video/uploadVideo`, formData)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.LOADING,
          payload: {
            loading: false,
          },
        });
        dispatch({
          type: ActionType.IMPORT_SHORT,
          payload: {
            data: res.data.videoSaved,
            totalNumber: res.data.totalVideos,
          },
        });
        setToast("success", "Short created Successfully !");
      }
    })
    .catch((error) => console.error(error));
};

export const editShort =
  (data, videoId, userId, channelIdFind, type, fullNameUser, uniqueVideoId) =>
  (dispatch) => {
    axios
      .patch(
        `${baseURL}admin/video/updateVideo?videoId=${videoId}&userId=${userId}&channelId=${channelIdFind}&videoType=${type}&uniqueVideoId=${uniqueVideoId}`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          dispatch({
            type: ActionType.EDIT_SHORT,
            payload: {
              data: res.data.video,
              videoId: videoId,
              fullName: fullNameUser,
            },
          });
          setToast(
            "success",
            `${
              type === 1 ? "Short Edit SuccessFully" : "Short Edit SuccessFully"
            }`
          );
        } else {
          setToast("error", res.data.message);
        }
      })
      .catch((error) => console.log("error", error.message));
  };

export const deleteShort = (id) => (dispatch) => {
  axios
    .delete(`${baseURL}admin/video/deleteVideo?videoId=${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: ActionType.DELETE_SHORT, payload: { id: id } });
        setToast("success", "Short Delete SuccessFully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const getHashTagApi = (filter, start, limit) => (dispatch) => {
  let data = {
    searchTag: filter.filter1 || "",
    feature: filter.filter2 || "",
  };
  console.log(data);
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/hashTag/hashtagForHome?start=${start}&limit=${limit}`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios
    .request(config)
    .then((res) => {
      dispatch({
        type: ActionType.HOMEHASHTAG,
        payload: {
          totalHashtag: res.data.totalHashTags,
          hashtagData: res.data.hashTags,
        },
      });
    })
    .catch((error) => {
      console.log(error);
    });
};
export const deleteHashtag = (id) => (dispatch) => {
  axios.delete(`${baseURL}admin/hashTag/deleteHashtag?id=${id}`).then((res) => {
    if (res.data.status) {
      dispatch({
        type: ActionType.DELETEHASHTAG,
        payload: { id: id },
      });
      setToast("success", "hashtag is deleted successfully");
    } else {
      setToast("error", res.data.message);
    }
  });
};
export const addHashtag = (data, start, limit) => (dispatch) => {
  let formatData = JSON.stringify({ hashtag: data });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/hashTag/addhashtag`,
    headers: {
      "Content-Type": "application/json",
    },
    data: formatData,
  };
  axios
    .request(config)
    .then((res) => {
      if (res.data.status) {
        setToast("success", res.data.message);
        dispatch(getHashTagApi(start, limit));
      }
    })
    .catch((error) => console.log(error));
};
export const updateHashtag = (Data, start, limit) => (dispatch) => {
  let formatData = JSON.stringify({ feature: Data });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/hashTag/updateFeature`,
    headers: {
      "Content-Type": "application/json",
    },
    data: formatData,
  };
  axios
    .request(config)
    .then((res) => {
      if (res.data.status) {
        // dispatch(getHashTagApi(start, limit));
        setToast("success", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};
export const updateOrderHashtags = (tags) => (dispatch) => {
  let data = JSON.stringify({ tags: tags });

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${baseURL}admin/hashtag/swapHashtagOrder`,
    headers: {
      key: secretKey,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      setToast("success", response.data.message);
    })
    .catch((error) => {
      console.log(error);
    });
};
export const getHashTags = () => (dispatch) => {
  let config = {
    method: "get",
    maxBodyLength: Infinity,
    url: `${baseURL}client/hashtag/FeatureHashtags`,
    headers: {
      key: secretKey,
    },
  };

  axios
    .request(config)
    .then((response) => {
      if (response.data.status) {
        dispatch({
          type: ActionType.GETFEATURETAGS,
          payload: { data: response.data },
        });
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
